import {AfterViewInit, Component, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';

// declare ga as a function to access the JS code in TS //declare google analytics
declare const ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit  {
  title = 'JioID';

  constructor(@Inject(PLATFORM_ID) private platformId: Object,private router: Router) {

    // old Google analytics code
    // this.router.events.subscribe(event => {

    //   if (event instanceof NavigationEnd) {
    //     ga('set', 'page', event.urlAfterRedirects);
    //     ga('send', 'pageview');
    //   }
    // });
  }

  ngAfterViewInit(): void {
    // new Google analytics code
    // this.initGoogleAnalyticsPageView();
  }

    // new Google analytics code
  // private initGoogleAnalyticsPageView() {
  //   const interval = setInterval(() => {
  //     if ((window as any).ga && (window as any).ga.getAll) {
  //       this.router.events.subscribe(event => {
  //         const ga = (window as any).ga
  //         if (event instanceof NavigationEnd) {
  //           const tracker = ga.getAll()[0]
  //           tracker.set('page', event.urlAfterRedirects)
  //           tracker.send('pageview')
  //         }
  //       })
  //       clearInterval(interval)
  //     }
  //   }, 50)
  // }


}
